<template>
  <div class="company-tooltip">
    <a-tooltip
      v-if="$getStrleng(text) > 40"
      :title="text"
      overlay-class-name="td-tooltip"
    >
      {{ $substr(text, 40) }}
    </a-tooltip>
    <span v-else>{{ text || '- -' }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
  .company-tooltip {
    display: inline;
  }
</style>
